import AppService from 'App/legacy/AppService';
export const goToContactCard = (contactId: number) => {
	Tools.$state.go('contact.dashboard', { id: contactId });
};

export const getContactCardHref = (contactId: number) => {
	return Tools.$state.href('contact.dashboard', {
		customerId: AppService.getCustomerId(),
		id: contactId
	});
};
